module.exports = __webpack_public_path__ + "static/img/third4.a12c1334.png";